import { useForm } from '@inertiajs/react'
import Logo from '../../components/Logo'

export default function Accept({ token, workspace, email, flash }) {
  const { post, processing } = useForm({})

  function handleAccept(e) {
    e.preventDefault()
    post(`/invitations/accept?token=${encodeURIComponent(token)}`)
  }

  return (
    <div className="min-h-screen bg-zinc-900 flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[500px] h-[500px] rounded-full bg-emerald-900/8 blur-3xl" />
      </div>

      <div className="w-full max-w-sm relative z-10">
        <div className="mb-10 flex flex-col items-center gap-5">
          <Logo variant="mark" size={120} />
          <p className="text-sm font-mono font-bold tracking-[0.5em] uppercase text-emerald-300">anamnesis</p>
        </div>

        {flash?.alert && (
          <div className="mb-4 px-4 py-2 bg-red-950 border border-red-800 rounded-lg text-sm text-red-400 font-mono">
            {flash.alert}
          </div>
        )}
        {flash?.notice && (
          <div className="mb-4 px-4 py-2 bg-emerald-950 border border-emerald-800 rounded-lg text-sm text-emerald-400 font-mono">
            {flash.notice}
          </div>
        )}

        <div className="bg-zinc-800/30 border border-zinc-600/50 rounded-2xl p-6 space-y-5">
          <div className="px-4 py-4 bg-zinc-800/60 border border-zinc-700 rounded-xl space-y-2">
            <p className="text-[10px] font-mono text-zinc-600 uppercase tracking-[0.18em]">
              Workspace invitation
            </p>
            <p className="text-sm font-mono text-zinc-100">
              You have been invited to join{' '}
              <span className="text-emerald-400 font-bold">{workspace?.name}</span>.
            </p>
            {email && (
              <p className="text-xs font-mono text-zinc-500">
                Sent to: {email}
              </p>
            )}
          </div>

          <form onSubmit={handleAccept}>
            <button
              type="submit"
              disabled={processing}
              className="w-full bg-emerald-800/60 hover:bg-emerald-700/80 disabled:opacity-50 disabled:cursor-not-allowed text-emerald-200 border border-emerald-700/40 font-mono text-sm font-semibold py-2.5 px-4 rounded-lg transition-colors"
            >
              {processing ? 'Joining...' : 'Accept invitation'}
            </button>
          </form>

          <p className="text-[10px] font-mono text-zinc-700 text-center">
            You must be logged in to accept.
          </p>
        </div>

        <p className="mt-6 text-center text-[10px] font-mono text-zinc-500 tracking-wider uppercase">
          persistent memory for AI agents
        </p>
      </div>
    </div>
  )
}
